export const DEFAULT_COLUMNS: string[] = [
	'issuetype',
	'issuekey',
	'summary',
	'reporter',
	'assignee',
	'status',
	'created',
];

export const DEFAULT_QUEUE_ID = Number.MIN_VALUE;
